{
  "title": "Commandes",
  "subtitle": "Toutes les commandes de tous les canaux, du brouillon au client.",
  "draftTitle": "Brouillon",
  "status": {
    "draft": "Brouillon",
    "placed": "Passée",
    "confirmed": "Confirmée",
    "completed": "Terminée",
    "cancelled": "Annulée"
  },
  "fulfillment": {
    "unfulfilled": "Non préparée",
    "inProgress": "En préparation",
    "fulfilled": "Remise",
    "partlyReturned": "Retour partiel",
    "returned": "Retournée"
  },
  "payment": {
    "unpaid": "Non payée",
    "partlyPaid": "Payée en partie",
    "paid": "Payée",
    "partlyRefunded": "Remboursée en partie",
    "refunded": "Remboursée"
  },
  "steps": {
    "picking": "Prélèvement",
    "packed": "Emballée",
    "shipped": "Expédiée",
    "delivered": "Livrée",
    "readyForPickup": "Prête au retrait",
    "collected": "Retirée",
    "handedOver": "Remise"
  },
  "modes": {
    "shipping": "Livraison",
    "pickup": "Retrait",
    "counter": "Au comptoir"
  },
  "tabs": {
    "open": "En cours",
    "toPrepare": "À préparer",
    "onTheWay": "En route",
    "drafts": "Brouillons",
    "completed": "Terminées",
    "cancelled": "Annulées",
    "all": "Toutes"
  },
  "list": {
    "new": "Nouvelle commande",
    "noCustomer": "Sans client",
    "search": "Numéro de commande ou client",
    "site": "Site",
    "allSites": "Tous les sites",
    "channel": "Canal",
    "allChannels": "Tous les canaux",
    "carrier": "Transporteur",
    "allCarriers": "Tous les transporteurs",
    "payment": "Paiement",
    "allPayments": "Tous les paiements",
    "due": "Reste à payer",
    "queueHint": "Les commandes confirmées à préparer et à remettre, les plus anciennes d’abord.",
    "showing_one": "{{first}}–{{last}} sur {{total}} commande",
    "showing_other": "{{first}}–{{last}} sur {{total}} commandes",
    "pricingMode": "Prix",
    "allPricingModes": "Détail et gros"
  },
  "empty": {
    "title": "Aucune commande pour le moment",
    "text": "Prenez une commande pour un client par téléphone ou au back-office ; les commandes en ligne arriveront ici aussi."
  },
  "noMatch": {
    "open": "Aucune commande en cours",
    "toPrepare": "Rien à préparer",
    "onTheWay": "Rien en route",
    "drafts": "Aucun brouillon",
    "completed": "Aucune commande terminée",
    "cancelled": "Aucune commande annulée",
    "all": "Aucune commande trouvée"
  },
  "columns": {
    "order": "Commande",
    "customer": "Client",
    "site": "Site",
    "status": "Statut",
    "payment": "Paiement",
    "total": "Total (TND)",
    "date": "Date",
    "product": "Article",
    "quantity": "Quantité",
    "unitPrice": "Prix unitaire",
    "discount": "Remise",
    "lineTotal": "Total"
  },
  "editor": {
    "newTitle": "Nouvelle commande",
    "editTitle": "Modifier le brouillon",
    "changeTitle": "Modifier la commande {{number}}",
    "changeHint": "Les lignes inchangées gardent leur prix ; les lignes nouvelles ou modifiées prennent celui du jour. Rien ne change avant d’enregistrer.",
    "saveChanges": "Enregistrer les modifications",
    "changed": "Commande {{number}} modifiée",
    "hint": "Enregistrée au fil de la saisie. Les prix viennent de la liste de prix du canal, TTC.",
    "saving": "Enregistrement…",
    "unsaved": "Modifications pas encore enregistrées",
    "saved": "Brouillon enregistré",
    "notSaved": "Pas encore enregistrée",
    "whoWhere": "Client et livraison",
    "channel": "Canal",
    "site": "Site",
    "siteHint": "D’où part le stock.",
    "siteFixed": "Le site du canal.",
    "pickSite": "Choisir un site",
    "customer": "Client",
    "customerSearch": "Téléphone, nom ou numéro client",
    "noCustomer": "Aucun client trouvé.",
    "newCustomer": "Nouveau client",
    "changeCustomer": "Changer",
    "delivery": "Livraison",
    "address": "Adresse de livraison",
    "pickAddress": "Choisir une adresse",
    "otherAddress": "Une autre adresse…",
    "addressFields": {
      "line1": "Adresse",
      "line2": "Complément d’adresse",
      "city": "Ville",
      "postalCode": "Code postal",
      "governorate": "Gouvernorat",
      "recipient": "Destinataire",
      "phone": "Téléphone à l’adresse"
    },
    "shippingFee": "Frais de livraison",
    "carrier": "Transporteur",
    "channelCarrier": "Celui du canal : {{name}}",
    "carrierLater": "Choisi à l’expédition",
    "pickupSite": "Point de retrait",
    "payment": "Moyen de paiement",
    "paymentLater": "Choisi plus tard",
    "promoCode": "Code promo",
    "promoCodeHint": "La promotion qui le demande s'applique alors.",
    "notes": "Notes pour l’équipe",
    "lines_one": "{{count}} ligne",
    "lines_other": "{{count}} lignes",
    "scanPlaceholder": "Scannez, ou tapez une référence ou un nom, puis Entrée",
    "noLines": "Aucun article : scannez un code-barres ou cherchez un article.",
    "available": "{{quantity}} {{unit}} disponible(s)",
    "removeLine": "Retirer {{name}}",
    "quantity": "Quantité",
    "unitPrice": "Prix unitaire",
    "discount": "Remise",
    "lineTotal": "Total",
    "placeConfirm": "Passer et réserver le stock",
    "placeOnly": "Passer sans réserver",
    "placeHint": "Passer la commande lui donne son numéro et fige ses prix ; réserver garde son stock.",
    "placed": "Commande {{number}} passée",
    "placedConfirmed": "Commande {{number}} passée, son stock est réservé",
    "pricingMode": "Prix",
    "wholesaleHint": "Chaque article à son prix de gros ; un article sans prix de gros ne peut pas être commandé.",
    "promotion": "{{name}} : −{{amount}}"
  },
  "totals": {
    "title": "Totaux",
    "lines": "Lignes",
    "discounts": "Remises",
    "shipping": "Livraison",
    "total": "Total",
    "tax": "Dont TVA {{rate}} %",
    "taxOn": "TVA {{rate}} % sur {{net}}",
    "empty": "Les totaux s’affichent dès que la première ligne est enregistrée."
  },
  "page": {
    "steps": "Étapes de la commande",
    "skipped": "Sautée",
    "lines_one": "{{count}} ligne",
    "lines_other": "{{count}} lignes",
    "vat": "TVA {{rate}} %",
    "returned": "{{quantity}} {{unit}} retourné(s)",
    "timeline": "Historique",
    "timelineHint": "Chaque étape, avec qui et quand.",
    "confirmed": "Commande {{number}} confirmée, son stock est réservé",
    "edit": "Modifier",
    "place": "Passer la commande",
    "confirm": "Réserver le stock",
    "return": "Reprendre des articles",
    "deliveryNote": "Bon de livraison",
    "cancel": "Annuler la commande",
    "cancelPicking": "Annuler le prélèvement",
    "cancelPickingTitle": "Annuler le prélèvement de {{number}} ?",
    "cancelPickingText": "La commande revient au début de sa préparation et peut de nouveau être modifiée. Son stock reste réservé : remettez en place ce qui a déjà été prélevé.",
    "pickingCancelled": "Prélèvement annulé : la commande peut être modifiée",
    "cancelledTitle": "Annulée",
    "placedTitle": "Passée, stock pas encore réservé",
    "placedText": "Réservez le stock pour confirmer la commande : le site la prépare ensuite.",
    "expiresTitle": "En attente du paiement en ligne",
    "expiresText": "Sans paiement avant le {{date}}, la commande est annulée et son stock libéré.",
    "shortTitle": "Pas assez de stock sur ce site",
    "shortLine": "{{name}} : {{available}} {{unit}} disponible(s)",
    "returns": "Retours",
    "lateReturn": "Après le délai de retour",
    "customer": "Client",
    "name": "Nom",
    "phone": "Téléphone",
    "email": "Email",
    "delivery": "Livraison",
    "mode": "Mode",
    "address": "Adresse",
    "pickupSite": "Point de retrait",
    "trackParcel": "Suivre le colis sur le site du transporteur",
    "returnUntil": "Retours acceptés jusqu’au",
    "details": "Détails",
    "payment": "Moyen de paiement",
    "promoCode": "Code promo",
    "priceList": "Liste de prix",
    "created": "Commencée",
    "placedAt": "Passée",
    "confirmedAt": "Confirmée",
    "completedAt": "Terminée",
    "tillCancelTitle": "Annulée en caisse le {{date}} par {{by}}",
    "approvedBy": "autorisé par {{name}}",
    "noReceiptTitle": "Repris en caisse sans ticket",
    "noReceiptText": "Articles rapportés repris au prix du jour et remboursés en espèces ; cette commande ne contient que ce retour."
  },
  "cancel": {
    "title": "Annuler {{number}} ?",
    "releases": "Son stock réservé est libéré aussitôt.",
    "confirm": "Annuler la commande",
    "reason": "Pourquoi",
    "note": "Note",
    "done": "{{number}} annulée",
    "reasons": {
      "customerRequest": "Le client l’a demandé",
      "outOfStock": "Rupture de stock",
      "paymentFailed": "Paiement échoué",
      "duplicate": "Saisie en double",
      "reservationExpired": "Non payée à temps",
      "other": "Autre raison"
    }
  },
  "step": {
    "done": "Étape faite : {{step}}",
    "carrier": "Transporteur",
    "tracking": "Numéro de suivi",
    "pickCarrier": "Choisir le transporteur",
    "noCarriers": "Aucun transporteur pour l’instant.",
    "addCarriers": "Ajouter des transporteurs",
    "handOverHint": "Le stock sort maintenant : des emplacements les plus remplis du site, au coût moyen.",
    "titles": {
      "picking": "Commencer le prélèvement de {{number}} ?",
      "packed": "{{number}} est emballée ?",
      "shipped": "Expédier {{number}}",
      "delivered": "{{number}} a été livrée ?",
      "readyForPickup": "{{number}} est prête au retrait ?",
      "collected": "Remettre {{number}} au client ?",
      "handedOver": "Remettre {{number}} ?"
    },
    "actions": {
      "picking": "Commencer le prélèvement",
      "packed": "Marquer emballée",
      "shipped": "Expédier",
      "delivered": "Marquer livrée",
      "readyForPickup": "Prête au retrait",
      "collected": "Retirée",
      "handedOver": "Remettre"
    },
    "texts": {
      "picking": "L’équipe commence à rassembler les articles ; l’alerte du site se ferme.",
      "packed": "Le colis est prêt à partir.",
      "shipped": "Le colis part avec le transporteur.",
      "delivered": "Le client a reçu le colis : la commande est terminée.",
      "readyForPickup": "La commande attend au point de retrait.",
      "collected": "Le client a pris la commande : son stock sort et la commande est terminée.",
      "handedOver": "Le client prend la commande maintenant : son stock sort et la commande est terminée."
    }
  },
  "return": {
    "title": "Reprendre des articles de {{number}}",
    "hint": "Le stock revient au coût auquel il était sorti. Les remboursements arrivent avec les paiements.",
    "confirm": "Reprendre",
    "done": "Retour enregistré",
    "lateTitle": "Le délai de retour est dépassé",
    "lateText": "Il a pris fin le {{date}} : seules les personnes autorisées à accepter les retours tardifs peuvent le faire.",
    "left": "{{quantity}} {{unit}} peuvent revenir",
    "quantityOf": "Quantité de {{name}} qui revient",
    "reason": "Pourquoi",
    "place": "Retour vers",
    "placeHint": "Un rayon, ou un emplacement pour les articles abîmés.",
    "note": "Note",
    "reasons": {
      "changedMind": "A changé d’avis",
      "defective": "Défectueux",
      "wrongItem": "Mauvais article",
      "damaged": "Endommagé",
      "other": "Autre raison"
    }
  },
  "note": {
    "title": "Bon de livraison",
    "print": "Imprimer",
    "to": "Livrer à",
    "how": "Livraison",
    "preparedBy": "Cachet et signature de l’expéditeur",
    "receivedBy": "Reçu en bon état par",
    "mode": "Mode",
    "pickup": "Point de retrait",
    "carrier": "Transporteur",
    "tracking": "N° de suivi",
    "remarks": "Observations",
    "dateTitle": "Date du bon de livraison"
  },
  "pricingModes": {
    "retail": "Détail (la liste du canal)",
    "wholesale": "Gros"
  }
}
